import classnames from "classnames"
import AriaLabel from "@mobi/components/AriaLabel"
import "./Tracking.scss"

import CloseIcon from "../../static/icons/outlined/fechar.svg"
import CheckIcon from "../../static/icons/outlined/check.svg"

interface IStep {
  //** Posição do passo na ordem do tracking */
  step: number
  //** Titulo do passo */
  title: string
  //** Sub texto do passo */
  text?: string
  //** Children do passo */
  children?: JSX.Element | string
  //** Aria label do children */
  childrenAriaLabel?: string
  //** Status do passo */
  status: "open" | "ongoing" | "done" | "failed"
  //** Set Aria-hidden como false */
  disableAriaHidden?: boolean
}

interface ITrackingProps {
  //** Lista de passos, deve seguir a estrutura de objeto de passos do exemplo */
  trackList: IStep[]
}

const createMarkup = (data) => ({
  __html: data,
})

const Tracking = ({ trackList }: ITrackingProps) => {
  const trackingBaseClass = "ds-tracking"

  const checkFailedStatus = (): boolean => {
    const hasFailedStatus = trackList.find((step) => step.status === "failed")

    if (hasFailedStatus !== undefined) {
      return true
    }

    return false
  }

  const handleAriaLabel = (step, status): string => {
    if (status === "open") {
      return `Passo ${step} em aberto`
    }

    if (status === "ongoing") {
      return `Passo ${step} em andamento`
    }

    if (status === "done") {
      return `Passo ${step} concluído`
    }

    if (status === "failed") {
      return `Passo ${step} paralizado`
    }

    return ""
  }
  
  const renderTrack = trackList.map((step, index) => {
    return (
      <li
        key={index}
        className={`${trackingBaseClass}__step ${trackingBaseClass}__step--${step.status}`}
      >
        <AriaLabel
          ariaText={ step?.disableAriaHidden ? `${handleAriaLabel(index + 1, step.status)}` : `${handleAriaLabel(index + 1, step.status)}, ${step.title
            } ${step.text ?? ""} ${step.childrenAriaLabel ?? ""}`}
        >
          <div className={`${trackingBaseClass}__container`} aria-hidden={ step?.disableAriaHidden ? "false" : "true" }>
            <i className={`${trackingBaseClass}__icon`}>
              {step.status === "done" && <CheckIcon />}
              {step.status === "failed" && <CloseIcon />}
            </i>
            <span aria-hidden={step?.disableAriaHidden ? "false" : "true"}>
              <strong>{step.title}</strong>
              {step.text && step.text !== "" && <br />}
              {step.text}
              {
                typeof step.children === "string" 
                ? <span {... { dangerouslySetInnerHTML: createMarkup(step.children) }} /> 
                : step.children
              }
            </span>
          </div>
        </AriaLabel>
      </li>
    )
  })

  const trackingClasses = classnames(trackingBaseClass, {
    [`${trackingBaseClass}--failed`]: checkFailedStatus(),
  })

  return <ul className={trackingClasses}>{renderTrack}</ul>
}

export default Tracking
